module.exports = "<bulk-bonuses-page></bulk-bonuses-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkBonuses.html
// module id = 1965
// module chunks = 0